import { Tabs } from 'antd';
import { Loading } from 'components';
import GeneralHeader from 'components/common/GeneralHeader';
import MyRequestTab from 'components/tabs-components/my_request';

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { GET } from 'utils';

const RequestApprovalDetail = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const url = `/api/absence_request/my_managed/${location.state.id}/`;
        GET(url).then((res) => {
          setData(res.data);
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      setLoading(false);
    };
    fetchData();
  }, [location.key]);

  if (loading) return <Loading />;
  return (
    <div>
      <GeneralHeader
        pageTitle={data && (data as any)?.absence_type?.name}
        icon="/icons/request_app.svg"
        status={data && (data as any)?.status}
        child={
          <Tabs
            style={{ marginTop: '70px' }}
            defaultActiveKey="1"
            items={[
              {
                key: '1',
                label: (
                  <div
                    style={{
                      color: '#0E3063',
                      fontSize: '20px',
                      margin: '0 10px',
                    }}
                  >
                    My request
                  </div>
                ),
                children: <MyRequestTab data={data} />,
              },
              // {
              //   key: '2',
              //   label: (
              //     <div style={{ color: '#0E3063', fontSize: '20px' }}>
              //       Repeat request
              //     </div>
              //   ),
              //   children: <>REPEAt REQUEST</>,
              // },
            ]}
          />
        }
      />
    </div>
  );
};

export default RequestApprovalDetail;
